export default __webpack_public_path__ + "static/media/milestone 1500.05b2c535.svg";